import { MoonLoader } from 'react-spinners'

const PaymentProcessingWidget = () => {
    return(
        <div className='paymentProcessingContainer'>
            <b>Your payment is being processed.</b>
            <div className='processingIndicator'>
                <MoonLoader size={30} />
            </div>
        </div>
    )
}

export default PaymentProcessingWidget;